// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__DVKqt","label":"Divider_label__mN1zG"};